import { createSlice } from '@reduxjs/toolkit';

const initialState = {
    isOpen: false,
    isMessageOpen: false,
    message: {}
};

const observedCropModal = createSlice({
    name: 'modal',
    initialState,
    reducers: {
   
        closeObservedCropModalModal(state) {
            state.isOpen = false;
       
        },
        openObservedCropModalModal(state, action) {
            state.isOpen = action.payload.isOpen;
        
        },
        openMessage(state,action) {
            state.isMessageOpen = true;
            state.message = action.payload.message;
        },
        closeMessage(state) {
            state.isMessageOpen = false;
            state.message = {} ;
        },

    }
});

export const { closeObservedCropModalModal, openObservedCropModalModal, openMessage,closeMessage } = observedCropModal.actions;

export default observedCropModal.reducer;